import { far, Icon, LoadingSpinner } from "../../component-library";
import { saveFileFromUrl } from "../../helper-functions";
import { CaseFile } from "../../models";
import { KeyboardEvent } from "react";

interface PhotoThumbnailProps {
    caseFile: CaseFile;
    url: string;
    maxHeight?: string;
    maxWidth?: string;
    className?: string;
    noDownload?: boolean;
}

export default function PhotoThumbnail({
    caseFile,
    url,
    maxHeight,
    maxWidth,
    className,
    noDownload,
}: Readonly<PhotoThumbnailProps>) {
    const { name: fileName } = caseFile;

    const handleClick = () => {
        if (noDownload) return;
        saveFileFromUrl(fileName ?? caseFile.path, url);
    };

    const handleKeyDown = (event: KeyboardEvent<Element>) => {
        if (noDownload) return;
        if (event.key === "Enter" || event.key === " ") {
            handleClick();
        }
    };

    if (url) {
        if (fileName?.endsWith(".pdf")) {
            return (
                <Icon
                    icon={far.faFilePdf}
                    height={"70px"}
                    onClick={handleClick}
                    onKeyDown={handleKeyDown}
                    tabIndex={noDownload ? undefined : 0}
                />
            );
        } else {
            return (
                <div>
                    <img
                        src={url}
                        alt={fileName}
                        className={className || "m-2"}
                        onClick={handleClick}
                        onKeyDown={handleKeyDown}
                        tabIndex={noDownload ? undefined : 0}
                        style={{
                            maxHeight: maxHeight || "200px",
                            maxWidth: maxWidth || "200px",
                            height: "auto",
                            width: "auto",
                            cursor: noDownload ? undefined : "pointer",
                        }}
                    />
                </div>
            );
        }
    }

    return (
        <div
            style={{ height: maxHeight || "150px", width: maxWidth || "150px", backgroundColor: "var(--bs-secondary)" }}
            className="p-3 m-2"
        >
            <LoadingSpinner />
        </div>
    );
}
